let { Checkbox } = require('../../../../../packages/account-ui');
let GreederColumns = require('./greeder-columns');
let Discount = require('./discount');
let Filter = require('./filter');
let FilterMulticolumn = require('./filter-multicolumn');
let Price = require('./price');
let css = require('./additional-parameters.css');
let signalsAddParams = require('../../../../../signals/custom-order/additional-parameters');

class AdditionalParameters {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let isSmallTree = this.$context.props.isSmallTree === 'true';
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }, { isSmallTree }));
    }
}

module.exports = {
    constructor: AdditionalParameters,
    children: [
        {
            name: 'checkbox',
            component: Checkbox,
            props: {
                signal: signalsAddParams.setExportColumnIsChecked
            },
            watcher: (attributes) => ({
                value: ['order', 'addParams', 'exportColumns', attributes['cat-path'], 'isChecked']
            })
        },
        // Нельзя просто сделать checkbox отмеченным, поэтому смотрим на переменную, которая всегда true
        {
            name: 'checkbox-basic',
            component: Checkbox,
            watcher: {
                value: ['order', 'computed', 'exportColumns', 'basic', 'alwaysTrue']
            }
        },
        {
            name: 'discount',
            component: Discount,
            watcher: (attributes) => ({
                discountPercentage: ['order', 'computed', 'exportColumns', 'optional', 'value', attributes['cat-path'],
                    'discountPercentage'],
                rowAmount: ['order', 'computed', 'exportColumns', 'optional', 'value', attributes['cat-path'],
                    'rowAmount'],
                isUseDiscounts: ['order', 'computed', 'exportColumns', 'optional', 'value', attributes['cat-path'],
                    'isUseDiscounts']
            })
        },
        {
            name: 'discount-basic',
            component: Discount,
            props: {
                isUseDiscounts: true
            },
            watcher: {
                discountPercentage: ['order', 'price', 'data', 'basic', 'discountPercentage'],
                rowAmount: ['order', 'price', 'data', 'total', 'rowAmount']
            }
        },
        {
            name: 'checkbox-only-head-cards',
            component: Checkbox,
            props: {
                signal: signalsAddParams.toggleOnlyHeadCards
            },
            watcher: {
                value: ['order', 'addParams', 'onlyHeadCards']
            }
        },
        {
            name: 'greeder-columns',
            component: GreederColumns,
            watcher: {
                columns: ['order', 'addParams', 'greederColumns', 'view', 'gosReg'],
                columnsRosstat: ['order', 'addParams', 'greederColumns', 'view', 'rosstat'],
                columnsKz: ['order', 'addParams', 'greederColumns', 'view', 'brr'],
                isShow: ['order', 'computed', 'isShowGreeder'],
                isDisabled: ['order', 'isDisabled'],
                isGosResSourceSelected: ['order', 'computed', 'isGosResSourceSelected']
            }
        },
        {
            name: 'filter',
            component: Filter,
            watcher: (attributes) => ({
                hasFilter: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view',
                    attributes['cat-path'], 'hasFilter'],
                filterType: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view',
                    attributes['cat-path'], 'filterType'],
                propertyName: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view',
                    attributes['cat-path'], 'propertyName'],
                filterName: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view',
                    attributes['cat-path'], 'filterName'],
                id: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view', attributes['cat-path'],
                    'id'],
                isDisabled: ['order', 'isDisabled']
            }),
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'filter-multicolumn',
            component: FilterMulticolumn,
            watcher: (attributes) => ({
                propertyName: ['order', 'computed', 'exportColumns', attributes['cat-type'], 'view',
                    attributes['cat-path'], 'propertyName']
            }),
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'price',
            component: Price,
            watcher: (attributes) => ({
                rowPrice: ['order', 'computed', 'exportColumns', 'optional', 'value', attributes['cat-path'],
                    'rowPrice'],
                rowPriceWithoutDiscount: ['order', 'computed', 'exportColumns', 'optional', 'value',
                    attributes['cat-path'], 'rowPriceWithoutDiscount']
            })
        },
        {
            name: 'price-basic',
            component: Price,
            watcher: {
                rowPrice: ['order', 'price', 'data', 'basic', 'rowPrice'],
                rowPriceWithoutDiscount: ['order', 'price', 'computed', 'rowPriceWithoutDiscount']
            }
        },
        {
            name: 'checkbox-archive-inn',
            component: Checkbox,
            props: {
                signal: signalsAddParams.toggleArchiveInn
            },
            watcher: {
                value: ['order', 'addParams', 'includeArchiveInn']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/additional-parameters/content/index.js